<template>
  <div class="outer-wrap" v-if="this.validSensors.length > 0" @click="undo">
    <div class="groups-wrapper" @click.stop>
      <header>
        <h2>FDD</h2>
        <a @click="undo" class="close"></a>
      </header>
      <div id="sensors-container">
        <h3>Gruppi:</h3>
        <div class="list-container">
          <div
            :class="[selectedGroup === group ? 'selected-item' : '', 'list-item']"
            v-for="group in actualGroups"
            :key="group"
            @click="selectedGroup = group"
          >
            Gruppo {{ group }}
          </div>
        </div>
        <div class="btns">
          <button class="group-btn" @click="addGroup">+</button>
        </div>
      </div>
      <div id="groups-container">
        <h3>Sensori del gruppo:</h3>
        <div class="list-container">
          <div class="list-item" v-for="sensor in validSensors" :key="sensor.eui">
            <label for="fddEnabled">{{ sensor.eui }}</label>
            <input
              type="checkbox"
              :name="sensor.eui"
              :id="sensor.eui"
              v-bind:checked="checkForSensorInGroup(sensor.eui)"
              @change="checkboxHandler($event, sensor.eui)"
            />
          </div>
        </div>
      </div>
      <footer class="buttons-container">
        <button id="edit" type="button" class="r1 c3" @click="undo">Annulla</button>
        <button id="save" type="button" class="r1 c5" @click="save">Salva</button>
        <button id="reset" type="button" class="r1 c1" @click="init">Reset</button>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "Groups",
  props: {
    structure: Object,
    sensorType: String,
  },
  data() {
    return {
      sensorGroups: [],
      selectedGroup: 1,
      validSensors: [],
    };
  },
  methods: {
    ...mapActions({
      updateGroups: "admin/updateFDDGroups",
    }),
    checkForSensorInGroup(sensorEui) {
      return this.sensorGroups.length > 0 && this.sensorGroups.some((sng) => sng.groups)
        ? this.sensorGroups.find((item) => item.eui === sensorEui).groups.includes(this.selectedGroup)
        : false;
    },
    undo() {
      this.$emit("close-groups");
    },
    async save() {
      if (confirm("ATTENZIONE! VERRANNO ELIMINATE TUTTE LE FDD PRECEDENTEMENTE CALCOLATE. PROCEDERE LO STESSO?")) {
        await this.updateGroups({ sensorType: this.sensorType, sensorGroups: this.sensorGroups });
        this.$emit("close-groups");
      }
    },
    init() {
      // Inizializzazione
      this.validSensors = JSON.parse(JSON.stringify(this.structure.sensors.filter((s) => s.type === this.sensorType)));
      this.sensorGroups = [];
      this.validSensors.map((sn) => {
        this.sensorGroups.push({ eui: sn.eui, groups: sn.groups });
      });
      // Se i sensori non hanno gruppo
    },
    addGroup() {
      let groupNumber = this.actualGroups[this.actualGroups.length - 1] + 1; // Worst case: ne aggiungo uno in coda
      for (let i = 0; i < this.actualGroups.length; i++) {
        if (this.actualGroups[i] > i + 1) {
          // Ho uno slot libero
          groupNumber = i + 1;
          break;
        }
      }
      // Se non esistevano i gruppi sui sensori...
      if (!this.sensorGroups[0].groups) {
        this.sensorGroups.map((sg) => (sg.groups = [1]));
        this.selectedGroup = 1;
      } else {
        this.sensorGroups[0].groups.push(groupNumber);
        this.selectedGroup = groupNumber;
      }
    },
    checkboxHandler(e, pippo) {
      let tempArray = this.sensorGroups.find((item) => item.eui === pippo).groups;
      if (e.target.checked) {
        // Sto selezionando
        tempArray.push(this.selectedGroup);
        this.sensorGroups.find((item) => item.eui === pippo).groups = tempArray.sort();
      } else {
        // Sto deselezionando
        this.sensorGroups.find((item) => item.eui === pippo).groups = tempArray.filter((e) => e !== this.selectedGroup).sort();
      }
    },
  },
  computed: {
    actualGroups() {
      // Lista ordinata dei gruppi che hanno almeno un sensore
      let tempGroups = [];
      this.sensorGroups
        .filter((sn) => sn.groups)
        .map((item) => {
          item.groups.map((group) => {
            if (!tempGroups.includes(group)) {
              tempGroups.push(group);
            }
          });
        });
      return tempGroups.sort();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
h3 {
  margin: 5px 0 10px 0;
}
.outer-wrap {
  z-index: 16;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.groups-wrapper {
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  overflow: hidden;
  width: 800px;
  height: fit-content;
  background-color: rgb(45, 48, 65);
  display: grid;
  grid-template-columns: 5fr 5fr;
  grid-template-rows: 60px 10fr 60px;
}
header {
  position: relative;
  padding: 0 10px;
  display: flex;
  align-items: center;
  grid-column: 1/3;
  border-bottom: solid 2px white;
  color: white;
}
footer {
  position: relative;
  grid-column: 1/3;
  border-top: solid 2px white;
  box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
}
#sensors-container {
  grid-row: 2;
  background-color: rgb(45, 48, 65);
  padding: 10px 30px 20px 30px;
  overflow: scroll;
}
#groups-container {
  grid-row: 2;
  background-color: rgb(45, 48, 65);
  padding: 10px 30px 20px 30px;
  overflow: scroll;
}
.list-container {
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: rgb(22, 25, 35);
  border-radius: 5px;
  width: 100%;
  height: 280px;
}
.list-item {
  cursor: pointer;
  text-align: left;
  padding: 5px 10px;
  background-color: rgb(45, 48, 65);
  margin: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
}
.selected-item {
  background-color: rgb(21, 146, 230);
}
.btns {
  display: flex;
  justify-content: center;
}
.group-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 10px 0;
  outline: none;
  border: none;
  background-color: rgb(80, 84, 105);
  color: white;
  font-weight: 800;
  font-size: 1.4em;
  border-radius: 5px;
}

.buttons-container {
  display: grid;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-template-columns: 25% 20% 25% 5% 25%;
  padding: 0 20px;
}
.buttons-container > button {
  font-size: 1em;
  margin: auto 0;
  height: 60%;
  font-weight: 700;
  outline-width: 0;
  outline: none !important;
  color: white;
  border-radius: 10px;
  border: solid 2px white;
  background-color: rgb(80, 84, 105);
}
.buttons-container > #save {
  background-color: rgb(21, 146, 230);
}
input[type="checkbox"] {
  height: 18px;
  width: 18px;
  margin: auto 15px auto;
}
.close {
  align-self: center;
  cursor: pointer;
  right: 2%;
  width: 3%;
}
</style>